const mutations = {
  setModels(state, data) {
    state.programaExamens = data.items;
    state.pagination = data._meta;
  },

  setModel(state, data) {
    state.programaExamen = data;
  },

  addModel(state, model) {
    state.record.nuevo = true;
    state.programaExamens.unshift(model);
  },

  updateModel(state, model) {
    const index = state.programaExamens
      .map(function (item) {
        return item.id;
      })
      .indexOf(model.id);
    state.programaExamens.splice(index, 1, model);
    state.record.actualizado = true;
  },

  delModel(state, id) {
    const removeIndex = state.programaExamens
      .map(function (item) {
        return item.id;
      })
      .indexOf(id);
    state.programaExamens.splice(removeIndex, 1);
  },

  setErrors(state, errors) {
    state.errorArray = errors;
  },

  setFields(state, data) {
    state.fields = data.fields;
    state.emptyModel = data.model;
  },
};
export default mutations;
